import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Chip,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Paper
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

const StartItemsSection = ({ startItems, onAddStartItem, onAddMultipleItems, onRemoveStartItem }) => {
  const [newStartItem, setNewStartItem] = useState('');
  
  // Handle adding a new start item
  const handleAddStartItem = () => {
    if (newStartItem.trim() === '') return;
    
    // Split by commas and add each item
    const itemsToAdd = newStartItem.split(',')
      .map(item => item.trim())
      .filter(item => item !== '');
    
    if (itemsToAdd.length === 0) return;
    
    console.log('[DEBUG] StartItemsSection processing items:', itemsToAdd);
    
    // If we have the batch function and multiple items, use it
    if (onAddMultipleItems && itemsToAdd.length > 1) {
      console.log('[DEBUG] StartItemsSection using batch add for multiple items');
      onAddMultipleItems(itemsToAdd);
    }
    // Otherwise fall back to adding items one by one
    else if (itemsToAdd.length === 1) {
      console.log('[DEBUG] StartItemsSection adding single item');
      onAddStartItem(itemsToAdd[0]);
    }
    else {
      console.log('[DEBUG] StartItemsSection fallback: Adding items one by one');
      itemsToAdd.forEach(item => onAddStartItem(item));
    }
    
    setNewStartItem('');
  };
  
  // Handle key press in the text field
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleAddStartItem();
    }
  };

  return (
    <Box>
      
      <Paper variant="outlined" sx={{ p: 3, mb: 3, borderRadius: 2 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Items to carry from the start of the race. You can add multiple items at once by separating them with commas.
        </Typography>
        
        <Box sx={{ display: 'flex', mb: 2 }}>
          <TextField
            fullWidth
            label="Add Start Line Items"
            value={newStartItem}
            onChange={(e) => setNewStartItem(e.target.value)}
            placeholder="e.g., Watch, Sunglasses, Hat (separate multiple items with commas)"
            onKeyPress={handleKeyPress}
          />
          <IconButton 
            color="primary" 
            onClick={handleAddStartItem}
            disabled={!newStartItem.trim()}
          >
            <AddIcon />
          </IconButton>
        </Box>
        
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {startItems.length > 0 ? (
            startItems.map((item, index) => (
              <Chip
                key={index}
                label={item}
                variant="outlined"
                onDelete={() => onRemoveStartItem(index)}
              />
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No start line items added
            </Typography>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default StartItemsSection; 